import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

const user = (state = null, action) => {
  switch (action.type) {
    case 'LOGIN':
      return action.payload? action.payload : null;
    case 'LOGOUT':
      return null;
  
    case 'FB_LOGIN':
      return (action.payload && action.payload.id)? action.payload : null;
    case 'FB_LOGOUT':
      return null;
    default:
      return state;
  }
}

const loading = (state=false,action) => (action.type === 'LOADING');
const userNotFound = (state=false,action) => (action.type === 'USER_NOTFOUND');
const connectionError = (state=false,action) => (action.type === 'CONNECTION_ERROR'? action.payload : false);
const ellenorzes = (state=0,action) => {
  switch (action.type) {
    case 'ELLENORIZNI_KELL': return state+1;
    case 'FB_LOGOUT':
    case 'CONNECTION_ERROR':
    case 'USER_INFO': return 0;
    default:
      return state;
  }
}

const userInfo = (state = null, action) => {
  switch (action.type) {
    case 'USER_INFO':
      return action.payload;
    case 'ELLENORIZNI_KELL':
    case 'FB_LOGOUT':
    case 'CONNECTION_ERROR':
    case 'USER_NOTFOUND':
      return null;
    default:
      return state;
  }
}

export default combineReducers({
  routing: routerReducer,
  loading,
  user,
  userInfo,
  userNotFound,
  connectionError,
  ellenorzes
})


// WEBPACK FOOTER //
// ./src/reducers.js